// todo: align content vertically center and horizontally left
<template>
  <v-card class="full-width" @click="$emit('click', $event)">
    <v-card-text class="minH">
      <v-row>
        <v-col md="6" sm="12" class="text-center">
          <v-avatar :size="dense ? 60 : 120" color="grey">            
              <span class="white--text display-2">{{text}}</span>        
          </v-avatar>
        </v-col>     
        <v-col md="6" sm="12">                                     
            <div :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" class="title">{{user.firstname}} {{user.lastname}}</div>                         
            <div class="body-2">{{user.phone}}</div>
            <div class="body-2">{{user.mobile}}</div>
            <div class="body-2 blue--text">{{user.mail}}</div>
        </v-col>                                         
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
 
export default {
    name: "AUserHeader",
    props: {
      user: Object,
      dense: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      text: function() {
        console.log(this.user);
        if (this.user) {
          const text = this.user.firstname.substr(0, 1) + this.user.lastname.substr(0, 1)
          return text.toUpperCase()
        }
        return '';
      }
    }
}
</script>

<style lang="scss" scoped>
  .minH {
    min-height: 150px;
    padding: 20px;
  }
  .full-width {
    width: 100%;
  }
</style>
